var Handlebars = require("../node_modules/_handlebars@4.5.3@handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "\"<span class=\"eruda-text-node\">"
    + container.escapeExpression(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":1,"column":31},"end":{"line":1,"column":40}}}) : helper)))
    + "</span>\"";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/textNode.hbs
// module id = 118
// module chunks = 0